
import { useRoute } from 'vue-router';

export default {
    name : "PsContentContainer",
    setup() {
        const route = useRoute();
        return {
            route
        }
    }
}
